<template>
  <AuthShell kicker="پنل مدیریت" code="V-01" title="ورود به وینو" description="برای ادامه، وارد حساب کاربری خود شوید.">
    <div class="login-tabs" role="group" aria-label="روش ورود">
      <button type="button" :class="{ active: activeTab === 'mobile' }" :aria-pressed="activeTab === 'mobile'" @click="switchTab('mobile')" :disabled="loading">رمز یک‌بارمصرف</button>
      <button type="button" :class="{ active: activeTab === 'password' }" :aria-pressed="activeTab === 'password'" @click="switchTab('password')" :disabled="loading">رمز عبور</button>
    </div>
    <form @submit.prevent="submit" novalidate>
      <label for="login-phone">شماره تلفن همراه</label>
      <input id="login-phone" class="auth-input" v-model="userPhoneNumber" type="tel" inputmode="numeric" autocomplete="username" placeholder="09123456789" :disabled="loading" dir="ltr" />
      <template v-if="activeTab === 'password'">
        <label for="login-password">رمز عبور</label>
        <input id="login-password" class="auth-input" v-model="userPassword" type="password" autocomplete="current-password" :disabled="loading" dir="ltr" />
      </template>
      <p v-if="errorMessage" class="auth-error" role="alert">{{ errorMessage }}</p>
      <button class="auth-submit" type="submit" :disabled="disabled" :aria-busy="loading">
        <span v-if="!loading">{{ activeTab === 'mobile' ? 'دریافت کد ورود' : 'ورود به پنل' }}</span>
        <span v-else><span class="spinner-border spinner-border-sm" aria-hidden="true"></span> در حال بررسی…</span>
      </button>
    </form>
    <p class="auth-help" v-if="activeTab === 'mobile'">کد ورود به شماره تلفن همراه شما پیامک می‌شود.</p>
  </AuthShell>
</template>
<script>
import AuthShell from '@/components/AuthShell/index.vue';

export default {
  components: { AuthShell },
  data() {
    return { userPhoneNumber: '', userPassword: '', loading: false, activeTab: this.$route.name === 'password' ? 'password' : 'mobile', errorMessage: '' };
  },
  computed: {
    disabled() { return this.loading || !/^0?9[0-9]{9}$/.test(this.userPhoneNumber) || (this.activeTab === 'password' && !this.userPassword); },
  },
  watch: {
    userPhoneNumber(value) {
      const normalized = value.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)).replace(/[٠-٩]/g, d => '٠١٢٣٤٥٦٧٨٩'.indexOf(d)).replace(/\D/g, '').slice(0, 11);
      if (value !== normalized) this.userPhoneNumber = normalized;
      this.errorMessage = '';
    },
  },
  methods: {
    switchTab(tab) { this.activeTab = tab; this.userPassword = ''; this.errorMessage = ''; },
    submit() { if (!this.disabled) return this.activeTab === 'mobile' ? this.submitPhone() : this.passwordLogin(); },
    async passwordLogin() {
      if (this.disabled) return;
      this.loading = true; this.errorMessage = '';
      try {
        const res = await this.$ApiServiceLayer.post(this.$PATH.RELATIVE_PATH.POST.PASSWORD_AUTH, '/api', { username: this.userPhoneNumber, password: this.userPassword }, {}, false);
        if (res.status === 200) {
          this.$STORE.commit('userConfig/setAccessToken', 'Bearer ' + res.data.access);
          this.$STORE.commit('userConfig/setRefreshToken', res.data.refresh);
          this.$STORE.commit('userConfig/setProjectInfo', null);
          this.$router.push({ name: 'projects' });
        } else this.errorMessage = res.status === 0 ? 'ارتباط با سرور برقرار نشد. دوباره تلاش کنید.' : 'ورود انجام نشد. شماره همراه و رمز عبور را بررسی کنید.';
      } finally { this.loading = false; }
    },
    async submitPhone() {
      if (this.disabled) return;
      this.loading = true; this.errorMessage = '';
      try {
        const res = await this.$ApiServiceLayer.post(this.$PATH.RELATIVE_PATH.POST.PHONE_NUMBER_OTP_REQ, this.$PATH.SERVICE_NAME.AUTH, { phone_number: this.userPhoneNumber }, {}, false);
        if (res.status === 201) {
          this.$STORE.commit('userConfig/setOtpId', res.data.id);
          this.$STORE.commit('userConfig/setLoginTempToken', res.data.verification_token);
          this.$STORE.commit('userConfig/setUserPhoneNumber', this.userPhoneNumber);
          this.$STORE.commit('userConfig/setProjectInfo', null);
          this.$router.push({ name: 'verify' });
        } else this.errorMessage = 'دریافت کد انجام نشد. لطفاً دوباره تلاش کنید.';
      } finally { this.loading = false; }
    },
  },
};
</script>
<style scoped>
.login-tabs { display: flex; gap: 0; margin-bottom: 26px; border-bottom: 1.5px solid rgba(2, 11, 45, .14); }
.login-tabs button { position: relative; flex: 1; min-height: 46px; font-size: 13.5px; font-weight: 700; border: 0; background: transparent; color: #4A557E; }
.login-tabs button::after { content: ''; position: absolute; inset-inline: 18%; bottom: -1.5px; height: 4px; background: var(--pink-500); transform: scaleX(0) skewX(var(--slant)); transition: transform .35s var(--ease-out); }
.login-tabs .active { color: var(--navy-900); font-weight: 900; }
.login-tabs .active::after { transform: scaleX(1) skewX(var(--slant)); }
</style>
